import React from "react";
import { useTranslation } from 'react-i18next';

import "../../pages/administration/AdministrationPage.css";
import FunctionalTableComponent from "../table/FunctionalTableComponent";
import columns from "./GlobalConfigTableConfig";
import {fields} from "./GlobalConfigFormConfig";
import renderUtils from "../../helpers/renderUtils";
import {hasAdminPanelFullAccess} from "../../helpers/jwt";


const GlobalConfigComponent = ({setLoader}) => {

    const { t } = useTranslation();

    function editionFields(editionItem) {
        return fields(
            editionItem?.type,
            renderUtils.renderEnumName(editionItem?.key, "globalConfigKey", t  ));
    }

    return (
        <>
            <FunctionalTableComponent
                className={"mt-5"}
                title={t("common.configuration_list")}
                columns={columns(t)}
                header={true}
                api={"globalConfig"}
                setLoader={setLoader}
                readOnly={!hasAdminPanelFullAccess()}
                removable={false}
                editable={true}
                width={6}
                tableHeader={false}
                pagination={false}
                editWithPost={true}
                editionFields={editionFields}
            />


        </>
    );
};


export default GlobalConfigComponent;
